import { authFetch } from './auth-fetch.js';

const overlay = document.getElementById('subscription-overlay');
const backdrop = document.getElementById('sub-overlay-backdrop');
const closeBtn = document.getElementById('sub-overlay-close');

const upsellSection = document.getElementById('sub-overlay-upsell');
const manageSection = document.getElementById('sub-overlay-manage');
const loadingEl = document.getElementById('sub-overlay-loading');
const activeEl = document.getElementById('sub-overlay-active');
const cancellingEl = document.getElementById('sub-overlay-cancelling');
const errorEl = document.getElementById('sub-overlay-error');
const ctaBtn = document.getElementById('sub-overlay-cta');
const cancelBtn = document.getElementById('sub-overlay-cancel-btn');
const reactivateBtn = document.getElementById('sub-overlay-reactivate-btn');
const renewsEl = document.getElementById('sub-overlay-renews');
const endsEl = document.getElementById('sub-overlay-ends');

function formatDate(timestamp) {
    return new Date(timestamp * 1000).toLocaleDateString(
        document.documentElement.lang || 'de',
        { year: 'numeric', month: 'long', day: 'numeric' }
    );
}

function showManageState(name) {
    [loadingEl, activeEl, cancellingEl, errorEl].forEach(el => {
        if (el) el.classList.add('hidden');
    });
    const target = { loading: loadingEl, active: activeEl, cancelling: cancellingEl, error: errorEl }[name];
    if (target) target.classList.remove('hidden');
}

function openPortal() {
    authFetch('/api/subscription/portal', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
    })
    .then(r => r.json())
    .then(data => {
        if (data.url) {
            window.location.href = data.url;
        } else {
            showManageState('error');
        }
    })
    .catch(() => showManageState('error'));
}

function close() {
    if (overlay) overlay.classList.add('hidden');
}

function open() {
    if (!overlay) return;

    const store = window.klarnachrichten?.login?.app?.store;
    const auth = store?.getState()?.auth;

    if (!auth?.isAuthenticated || !auth?.user) return;

    let metadata = auth.user.metadata;
    if (typeof metadata === "string") {
        try { metadata = JSON.parse(metadata); } catch (e) { metadata = {}; }
    }
    const hasSubscription = !!metadata?.subscription;

    // Reset visibility
    upsellSection?.classList.add('hidden');
    manageSection?.classList.add('hidden');

    overlay.classList.remove('hidden');

    if (hasSubscription) {
        manageSection?.classList.remove('hidden');

        const currentPeriodEnd = metadata?.subscriptionCurrentPeriodEnd;
        const cancelAtPeriodEnd = !!metadata?.subscriptionCancelAtPeriodEnd;

        if (cancelAtPeriodEnd) {
            if (endsEl && currentPeriodEnd) endsEl.textContent = formatDate(currentPeriodEnd);
            showManageState('cancelling');
        } else {
            if (renewsEl && currentPeriodEnd) renewsEl.textContent = formatDate(currentPeriodEnd);
            showManageState('active');
        }
    } else {
        upsellSection?.classList.remove('hidden');
    }
}

// CTA button — build Stripe payment link with prefilled_email and client_reference_id
ctaBtn?.addEventListener('click', () => {
    const paymentLink = window.klarnachrichtenConfig?.stripePaymentLink;
    if (!paymentLink) return;

    const store = window.klarnachrichten?.login?.app?.store;
    const auth = store?.getState()?.auth;
    const params = new URLSearchParams();

    if (auth?.user?.email) params.set('prefilled_email', auth.user.email);
    if (auth?.user?.id) params.set('client_reference_id', auth.user.id);

    const url = params.toString() ? `${paymentLink}?${params.toString()}` : paymentLink;
    window.location.href = url;
});

// Cancel / reactivate — open Stripe billing portal
cancelBtn?.addEventListener('click', () => openPortal());
reactivateBtn?.addEventListener('click', () => openPortal());

// Close handlers
closeBtn?.addEventListener('click', close);
backdrop?.addEventListener('click', close);
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay && !overlay.classList.contains('hidden')) {
        close();
    }
});

window.klarnachrichten.openSubscriptionOverlay = open;
